export const claimsAdviceSubscriberHistoryColumns = [
  'id',
  'fk_claims_advice_meta_data_id',
  'subscriber_entity_id',
  'subscriber_name',
  'subscriber_addr_street_1',
  'subscriber_addr_street_2',
  'subscriber_city',
  'subscriber_state',
  'subscriber_postal_code',
  'subscriber_country_code',
  'subscriber_ref_id_code',
  'subscriber_ref_id_desc',
  'subscriber_contact_id',
  'subscriber_contact_name',
  'subscriber_contact_type',
  'subscriber_contact_phone',
  'delimiter',
  'trx_key',
  'meta_lineage_source_system_name',
  'meta_lineage_source_name',
  'meta_lineage_source_offset',
  'meta_load_dt',
  'meta_correlation_id',
  'meta_component',
  'snapshot_id',
];
